module.exports = __webpack_public_path__ + "static/img/lms.5ea5b9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lms.jpg
// module id = rUeS
// module chunks = 2